var giphy_viewer_default = {
  "giphyWrapper": "o20yc",
  "giphy_player": "WOEco",
  "playIcon": "R0NpC",
  "gifRatio": "_56dOF"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
